import { batch, signal } from "@preact/signals-react"


// The open Settings tab; `null` until the page has read `?tab=`
export const userSettingsTab = signal(null)

// Tabs with a draft register what leaving them would lose: `{ [tabId]: { label, count: () => n } }`.
// One guard for every tab with a Save (Account here; Iris, CU-869fkmt6r, registers the same way).
export const settingsLeaveGuards = signal({})

/** Registers a tab's guard; returns the function that removes it. */
export function registerLeaveGuard(tab, guard) {
	settingsLeaveGuards.value = { ...settingsLeaveGuards.value, [tab]: guard }
	return () => {
		if (settingsLeaveGuards.value[tab] !== guard) return
		const { [tab]: _removed, ...rest } = settingsLeaveGuards.value
		settingsLeaveGuards.value = rest
	}
}

export const clearSettingsTabs = () => batch(() => {
	userSettingsTab.value = null
	settingsLeaveGuards.value = {}
})
